import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "menuGroup",
  title: "Menu Group",
  type: "object",
  preview: {
    select: {
      name: "target.title"
    },
    prepare({ name }) {
      return {
        title: multilingualStringPreview(name)
      };
    }
  },
  fields: [
    {
      name: "target",
      title: "Target",
      type: "reference",
      validation: (Rule) => Rule.required(),
      to: [
        { type: "page" },
        { type: "landingPage" },
        { type: "offersTermsAndConditions" }
      ]
    },
    {
      name: "menuItems",
      title: "Menu Items",
      type: "array",
      of: [
        {
          type: "menuItem"
        },
        {
          type: "linkCTA"
        }
      ]
    }
  ]
});
